import {DomainEvent} from './DomainEvent';
import {District} from '../resources/District';

export class DistrictUpdated extends DomainEvent<District> {}
